import React from "react";
import styled from "styled-components";
import ToggleOffIcon from "@icons/ToggleOffIcon.svg";
import ToggleOnIcon from "@icons/ToggleOnIcon.svg";

const StyledToggleOffIcon = styled(ToggleOffIcon)`
    fill: ${(props) => props.theme.textColorSecondary};
`;

const StyledToggleOnIcon = styled(ToggleOnIcon)`
    fill: ${(props) => props.theme.textColorPrimary};
`;

const ToggleDiv = styled.div<{ disabled: boolean }>`
    display: flex;
    opacity: ${(props) => (props.disabled ? "0.5" : "1")};
    cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
`;

interface LifeAtToggleProps {
    /**
     * If toggle is currently enabled (on or off)
     */
    readonly isEnabled: boolean;
    /**
     * Handle when toggle's enabled state changes
     */
    readonly onChange: () => void;
    /**
     * If the toggle is disabled from interacting.
     */
    readonly disabled?: boolean;
    className?: string;
}

export default function LifeAtToggle(props: LifeAtToggleProps) {
    const handleToggle = () => {
        if (!props.disabled) {
            props.onChange();
        }
    };

    return (
        <ToggleDiv onClick={handleToggle} disabled={props.disabled ?? false}>
            {props.isEnabled ? <StyledToggleOnIcon /> : <StyledToggleOffIcon />}
        </ToggleDiv>
    );
}
